import { createElementIdSlice } from '../utils/action/createElementSlice';
export const ButtonBarState = createElementIdSlice({
    elementName: 'button-bar',
    initialState: {},
    reducers: {},
});
